import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'

// 导入各个模块的初始状态和 mutations
import account from './modules/account'
import tagsList from './modules/tagsList'
import menuList from './modules/menuList'
import openedSubmenu from './modules/openedSubmenu'
import page from './modules/page'
import settings from './modules/settings'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  actions,
  getters,
  strict: debug,
  // 组合各个模块
  modules: {
    account,
    tagsList,
    menuList,
    openedSubmenu,
    page,
    settings
  }
})

settings.actions.getAllSettings(store)
export default store
